import script from "./BollingerPercentB.vue?vue&type=script&lang=js"
export * from "./BollingerPercentB.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__